import i18n from 'constants/translation/i18n';

const comlianceEstAreas = (t?: any) => {
  const entries = [
    {
      area: 'clientReq',
      title: t ? t('COMP_EST') : i18n.t('COMP_EST'),
      href: '/complianceEst/clientReq'
    },
    {
      area: 'dataManagement',
      title: t ? t('AUDIT_FINDINGS') : i18n.t('AUDIT_FINDINGS'),
      href: '/workingAreaDetails/audit-findings'
    },
    {
      area: 'master_data_management',
      title: t ? t('DATA_MANAGEMENT') : i18n.t('DATA_MANAGEMENT'),
      href: '/data_management_workflow',
      infoText: ''
    },
    {
      area: 'reporting',
      title: t ? t('REPORTS') : i18n.t('REPORTS'),
      href: '/reporting'
    },
    {
      area: 'dependencies',
      title: t ? t('DEPENDENCY_TREE') : i18n.t('DEPENDENCY_TREE'),
      href: '/dependencies'
    }
  ];
  return entries;
};

export default comlianceEstAreas;
